import showKey from './showKey'
const showAuthor = new Map(
  [
    [showKey.murongziying, "-- 慕容紫英"]
    ,[showKey.kobe, "-- Kobe Bryant"]
    ,[showKey.wusheng, "-- 伍声2009"]
    ,[showKey.xzSuccess, "-- 小障如是说"]
    ,[showKey.xzing, "-- 小障如是说"]
    ,[showKey.xzWarning, "-- 小障如是说"]
    ,[showKey.xzError, "-- 小障如是说"]
  ]
)
export default showAuthor



// WEBPACK FOOTER //
// ./src/cnConst/showAuthor.js